export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/[country]": [4,[2]],
		"/[country]/installations": [5,[2]],
		"/[country]/installations/[id]": [6,[2]],
		"/[country]/jobs": [7,[2]],
		"/[country]/jobs/installations/[installationId]": [9,[2]],
		"/[country]/jobs/[jobId]": [8,[2]],
		"/[country]/manifests": [10,[2]],
		"/[country]/manifests/new": [12,[2]],
		"/[country]/manifests/[id]": [11,[2]],
		"/[country]/nxt": [13,[2]],
		"/[country]/software-rollouts": [14,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';